// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d506da58","431":"95942112","453":"1aecd90a","455":"2e75ebad","857":"b8ab4670","977":"1787477d"}[chunkId] + ".chunk.js";
};